/* eslint-disable */
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n, { InitOptions, Services } from 'i18next';

import SurveysES from './locales/es/surveys/translation.json';
import CookiesES from './locales/es/cookies/translation.json';
import PrivacyES from './locales/es/privacy/translation.json';
import LopdES from './locales/es/lopd/translation.json';
import LegalES from './locales/es/legal/translation.json';
import InvalidDataES from './locales/es/invalid-data/translation.json';
import ExpiredLinkES from './locales/es/expired-link/translation.json';
import CompletedES from './locales/es/completed/translation.json';
import CancelledES from './locales/es/cancelled/translation.json';
import ContactES from './locales/es/contact/translation.json';
import ComponentsES from './locales/es/components/translation.json';
import CommonES from './locales/es/common/translation.json';
import AuthES from './locales/es/auth/translation.json';
import UbicationES from './locales/es/auth/translation.json';
import AssistanceES from './locales/es/assistance/translation.json';
import AiaES from './locales/es/aia/translation.json';
import LandingES from './locales/es/landing/translation.json';
import HasAssistanceES from './locales/es/has-assistance/translation.json';
import ImbeeES from './locales/es/imbee/translation.json';
import WantToCallMeES from './locales/es/want-to-callme/translation.json';

import ComponentsEN from './locales/en/components/translation.json';
import CommonEN from './locales/en/common/translation.json';
import AssistanceEN from './locales/en/assistance/translation.json';
import SurveysEN from './locales/en/surveys/translation.json';
import ContactEN from './locales/en/contact/translation.json';
import InvalidDataEN from './locales/en/invalid-data/translation.json';
import ExpiredLinkEN from './locales/en/expired-link/translation.json';
import CompletedEN from './locales/en/completed/translation.json';
import CancelledEN from './locales/en/cancelled/translation.json';
import AiaEN from './locales/en/aia/translation.json';
import LegalEN from './locales/en/legal/translation.json';
import LopdEN from './locales/en/lopd/translation.json';
import CookiesEN from './locales/en/cookies/translation.json';
import PrivacyEN from './locales/en/privacy/translation.json';
import AuthEN from './locales/en/auth/translation.json';
import UbicationEN from './locales/en/auth/translation.json';
import LandingEN from './locales/en/landing/translation.json';
import HasAssistanceEN from './locales/en/has-assistance/translation.json';
import ImbeeEN from './locales/en/imbee/translation.json';
import WantToCallMeEN from './locales/en/want-to-callme/translation.json';

import ComponentsCA from './locales/ca/components/translation.json';
import CommonCA from './locales/ca/common/translation.json';
import AssistanceCA from './locales/ca/assistance/translation.json';
import SurveysCA from './locales/ca/surveys/translation.json';
import ContactCA from './locales/ca/contact/translation.json';
import InvalidDataCA from './locales/ca/invalid-data/translation.json';
import ExpiredLinkCA from './locales/ca/expired-link/translation.json';
import CompletedCA from './locales/ca/completed/translation.json';
import CancelledCA from './locales/ca/cancelled/translation.json';
import AiaCA from './locales/ca/aia/translation.json';
import LegalCA from './locales/ca/legal/translation.json';
import LopdCA from './locales/ca/lopd/translation.json';
import CookiesCA from './locales/ca/cookies/translation.json';
import PrivacyCA from './locales/ca/privacy/translation.json';
import AuthCA from './locales/ca/auth/translation.json';
import UbicationCA from './locales/ca/auth/translation.json';
import LandingCA from './locales/ca/landing/translation.json';
import HasAssistanceCA from './locales/ca/has-assistance/translation.json';
import ImbeeCA from './locales/ca/imbee/translation.json';
import WantToCallMeCA from './locales/ca/want-to-callme/translation.json';

import Cookie from 'js-cookie';
import { DEFAULT_LANGUAGE, Language, SUPPORTED_LANGUAGES } from '../constants';
import { has } from 'cypress/types/lodash';

let languageUtils: any = {};

void i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .use({
    type: 'languageDetector',
    async: false,
    init: function (services: Services, detectorOptions: object, i18nextOptions: InitOptions) {
      languageUtils = services.languageUtils;
    },
    detect: function () {
      const lngDetector = new LanguageDetector();
      lngDetector.init({ languageUtils });
      const detectedLanguage = lngDetector.detect([
        'cookie',
        'querystring',
        'localStorage',
        'sessionStorage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ]);
      let language: string = '';
      if (Array.isArray(detectedLanguage) && detectedLanguage.length > 0) language = detectedLanguage[0];
      else if (typeof detectedLanguage === 'string') language = detectedLanguage;
      language = language.split('-')[0];
      if (!language || !SUPPORTED_LANGUAGES.includes(language as Language)) return DEFAULT_LANGUAGE;
      return language;
    },

    cacheUserLanguage: function (lng: string) {
      // localStorage.setItem('i18nextLng', lng);
      Cookie.set('i18next', lng);
    },
  })
  .init({
    ns: ['common', 'installPrompt', 'components'],
    defaultNS: 'common',
    // lng: 'es',
    fallbackLng: { default: [DEFAULT_LANGUAGE] },
    // supportedLngs: ['es', 'en', 'ca', 'es-VE'],
    nonExplicitSupportedLngs: true,
    cleanCode: true,
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    },

    resources: {
      es: {
        components: ComponentsES,
        auth: AuthES,
        ubication: UbicationES,
        common: CommonES,
        assistance: AssistanceES,
        surveys: SurveysES,
        contact: ContactES,
        invalidData: InvalidDataES,
        expiredLink: ExpiredLinkES,
        completed: CompletedES,
        cancelled: CancelledES,
        aia: AiaES,
        cookies: CookiesES,
        legal: LegalES,
        lopd: LopdES,
        privacy: PrivacyES,
        landing: LandingES,
        hasAssistance: HasAssistanceES,
        imbee: ImbeeES,
        wantToCallMe: WantToCallMeES,
      },
      en: {
        auth: AuthEN,
        ubication: UbicationEN,
        components: ComponentsEN,
        common: CommonEN,
        assistance: AssistanceEN,
        surveys: SurveysEN,
        contact: ContactEN,
        invalidData: InvalidDataEN,
        expiredLink: ExpiredLinkEN,
        completed: CompletedEN,
        cancelled: CancelledEN,
        aia: AiaEN,
        cookies: CookiesEN,
        legal: LegalEN,
        lopd: LopdEN,
        privacy: PrivacyEN,
        landing: LandingEN,
        hasAssistance: HasAssistanceEN,
        imbee: ImbeeEN,
        wantToCallMe: WantToCallMeEN,
      },
      ca: {
        auth: AuthCA,
        ubication: UbicationCA,
        components: ComponentsCA,
        common: CommonCA,
        assistance: AssistanceCA,
        surveys: SurveysCA,
        contact: ContactCA,
        invalidData: InvalidDataCA,
        expiredLink: ExpiredLinkCA,
        completed: CompletedCA,
        cancelled: CancelledCA,
        aia: AiaCA,
        cookies: CookiesCA,
        legal: LegalCA,
        lopd: LopdCA,
        privacy: PrivacyCA,
        landing: LandingCA,
        hasAssistance: HasAssistanceCA,
        imbee: ImbeeCA,
        wantToCallMe: WantToCallMeCA,
      },
    },
  });

export default i18n;
